var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFuelTank(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Calque_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 100 100",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#f8e5be;}.cls-2{fill:#69531f;}.cls-3{fill:#eee;}.cls-4{fill:#fbcd7a;}.cls-5{fill:#7e7770;}.cls-6{fill:#41939e;}.cls-7{fill:#555759;}.cls-8{fill:#3a3a3a;}.cls-9{fill:#5a5b54;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Fuel_Tank"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m1.06,52.2l74.22,42.99c.67.39,1.49.38,2.15-.01l17.15-10.26c1.38-.83,1.37-2.83-.02-3.64L20.78,38.07c-.66-.39-1.49-.39-2.15,0L1.03,48.55c-1.39.83-1.38,2.84.02,3.65Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "59.1 79.99 64.37 83.08 64.37 68.54 59.1 65.76 59.1 79.99"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-8",
    points: "64.37 83.08 73.41 77.96 73.41 67.34 65.28 62.89 59.1 65.76 64.37 68.54 64.37 83.08"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "12.55 54.01 17.82 57.09 17.82 42.56 12.55 39.77 12.55 54.01"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-8",
    points: "17.82 57.09 26.86 51.97 26.86 41.35 18.73 36.91 12.55 39.77 17.82 42.56 17.82 57.09"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m74.01,78.97c-.15-.06-.29-.13-.44-.19l-2.21-1.25s-.02,0-.03-.02L9.07,42.36l-2.31-1.31C-.82,35.8-2.03,24.41,4.05,15.58c5.54-8.03,15.21-11.16,22.64-7.72l2.09,1.18,1.52.86c-7.36-3.12-16.76.04-22.19,7.91-6.08,8.82-4.87,20.22,2.72,25.47l2.31,1.31,60.89,34.39Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m74.07,57.33c-4.6,8.78-3.77,18.41,1.73,22.26-.61-.17-1.2-.37-1.78-.61L13.12,44.58l-2.31-1.31c-7.58-5.25-8.8-16.64-2.72-25.47,5.43-7.87,14.83-11.03,22.19-7.91l60.83,34.36,2.26,1.27s0,0,.01,0c.68.47,1.3.98,1.88,1.54-.28-.18-.56-.36-.86-.51-6.37-3.34-15.48,1.48-20.35,10.76Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m95.28,47.08s0,0,0,0c-.28-.18-.56-.36-.86-.51-6.37-3.34-15.48,1.48-20.35,10.76-4.6,8.78-3.77,18.41,1.73,22.26,7.03,1.92,15.35-1.34,20.33-8.56.39-.57.75-1.15,1.08-1.73,1.4-2.69,2.28-5.45,2.67-8.1.61-5.37-.98-10.58-4.59-14.1Zm.55,21.99c-2.86,5.46-8.12,8.35-11.74,6.45-3.62-1.9-4.23-7.87-1.36-13.33,2.86-5.46,8.12-8.35,11.74-6.45,3.62,1.9,4.23,7.87,1.36,13.33Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m95.83,69.07c-2.86,5.46-8.12,8.35-11.74,6.45-3.62-1.9-4.23-7.87-1.36-13.33,2.86-5.46,8.12-8.35,11.74-6.45,3.62,1.9,4.23,7.87,1.36,13.33Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "m62.79,60.22s5.21-19.46,21.14-20.03l-2.94-1.66s-13.76-2.98-20.91,20.11l2.71,1.58Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "m10.49,30.69S15.7,11.23,31.63,10.66l-2.94-1.66S14.94,6.02,7.78,29.11l2.71,1.58Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m57.42,30.71c0,.17-.02.35-.05.51-.4,2.05-3.19,3.64-6.56,3.64s-6.16-1.59-6.56-3.64c-.03-.17-.05-.34-.05-.51,0-2.29,2.96-4.15,6.61-4.15s6.61,1.86,6.61,4.15Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m59.57,27.11c0,.22-.02.44-.07.65-.51,2.6-4.03,4.6-8.3,4.6s-7.79-2.01-8.29-4.6c-.04-.21-.07-.43-.07-.65,0-2.9,3.74-5.25,8.36-5.25s8.36,2.35,8.36,5.25Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "m59.57,28.41c0,2.9-3.74,5.26-8.36,5.26s-8.36-2.36-8.36-5.26c0-.22.02-.44.07-.65.51,2.6,4.02,4.6,8.29,4.6s7.79-2.01,8.3-4.6c.04.21.07.43.07.65Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFuelTank);
export default __webpack_public_path__ + "static/media/fuel-tank.4600da73ea4336a0ec5a9b75c039c50b.svg";
export { ForwardRef as ReactComponent };